import { Box, useTheme } from "@mui/material";
import Header from "../../../component/Dashboard/Header";

import { tokens } from "../../../theme";
import CustomizedAccordions from "./accordion_";

const FAQ = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box m="100px"
      sx={{
        ".faq-section": {
          maxWidth: '70%'
        }
      }}
    >
      <Box marginTop={"8rem"}><Header title="FAQ" subtitle="Frequently Asked Questions Page" /></Box>
      <section className="faq-section">
        <CustomizedAccordions />
      </section>

    </Box>
  );
};

export default FAQ;
